import template from './changePassword.html';

export function ChangePasswordViewModel() {
}

// The default export returns the component details object to register with KO
export default { viewModel: ChangePasswordViewModel, template: template };

